import {
  onCLS,
  onFID,
  onFCP,
  onTTFB,
  onLCP,
} from 'web-vitals';

export const pushWebVitalsToDataLayer = () => {
  if (typeof window !== 'undefined') {
    // eslint-disable-next-line no-inner-declarations
    function sendToDatalayer(name) {
      window.dataLayer = window.dataLayer || [];
      // If the event is already in the dataLayer, don't push it again.
      // This check is here because rerenders are causing the event to be pushed multiple times.
      if (!window.dataLayer.find(o => o.event === 'web-vitals' && o.event_action === name.name)) {
        ononline = window.dataLayer.push({
          event: 'web-vitals',
          event_category: 'Performance',
          event_action: name.name,
          event_value: Math.round(name.name === 'CLS' ? name.delta * 1000 : name.delta),
          event_label: name.id,
          webvitals_metric: name.name,
          webvitals_metric_value: Math.round(name.name === 'CLS' ? name.delta * 1000 : name.delta),
          webvitals_id: name.id,
        });
      }
    }

    if (typeof document !== 'undefined') {
      onCLS(sendToDatalayer);
      onFID(sendToDatalayer);
      onLCP(sendToDatalayer);
      onFCP(sendToDatalayer);
      onTTFB(sendToDatalayer);
    }
  }
};
